import axios from "axios";
import { cmsEnv, cmsHeaders } from "../exports/exports";
import { dynamicFailed } from "../hooks/useToast";

export const fetchFellowShipBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/our-training-fellowship-banner`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
  }
};

export const fetchFellowShipTestimonials = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/our-training-fellowship-testimonial`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
  }
};

export const fetchObserverShipBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/our-training-observership-banner`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
  }
};
